"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _laddaOriginal = _interopRequireDefault(require("laddaOriginal"));

var _MarkViOnButton = _interopRequireDefault(require("web-common/scripts/views/MarkViOnButton"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalCreate = _laddaOriginal.default.create;

_laddaOriginal.default.create = function (button) {
  var instance = originalCreate(button);

  instance.success = function (alertElement, options) {
    instance.stop();

    _MarkViOnButton.default.animate((0, _jquery.default)(button), alertElement, options);
  };

  instance.error = function () {
    instance.stop();
  };

  return instance;
};

var _default = _laddaOriginal.default;
exports.default = _default;